/*
 * Module for Communication Settings edit view
 */
rs.module("framework/content/communicationsettings/edit",

    ["common/visibility", "common/select-helper"],

    function (visibility, selectHelper) {

        function initialize(jsSelectors, backendUrls, constants) {

            var form = $.js(jsSelectors.form);

            // initialize JS selectors
            var batchType = form.js(jsSelectors.batchType, { required: false });
            var sendTo = form.js(jsSelectors.sendTo);
            var headingAddressType = form.js(jsSelectors.headingAddressType);
            var headingAddress = form.js(jsSelectors.headingAddress);
            var deliveryMethod = form.js(jsSelectors.deliveryMethod);
            var emailInfoPanel = form.js(jsSelectors.emailInfoPanel);
            var emailType = form.js(jsSelectors.emailType);
            var email = form.js(jsSelectors.email);
            var emailAdditionalInfoPanel = form.js(jsSelectors.emailAdditionalInfoPanel);
            var selectedPasswordType = form.js(jsSelectors.selectedPasswordType);
            var changePasswordLink = form.js(jsSelectors.changePasswordLink, { required: false });
            var customPasswordPanel = form.js(jsSelectors.customPasswordPanel);
            var hasPasswordChanged = form.js(jsSelectors.hasPasswordChanged);
            var originalPassword = form.js(jsSelectors.originalPassword);
            var originalPasswordPlaceholder = form.js(jsSelectors.originalPasswordPlaceholder, { required: false });
            var confirmedPassword = form.js(jsSelectors.confirmedPassword);
            var confirmedPasswordPlaceholder = form.js(jsSelectors.confirmedPasswordPlaceholder, { required: false });
            var ccRecipient = form.js(jsSelectors.ccRecipient);
            var ccEmailType = form.js(jsSelectors.ccEmailType);
            var ccEmail = form.js(jsSelectors.ccEmail);

            // initialize select helpers
            var sendToSelectHelper = selectHelper.getHelper(sendTo);
            var headingAddressTypeSelectHelper = selectHelper.getHelper(headingAddressType);
            var emailTypeSelectHelper = selectHelper.getHelper(emailType);
            var ccRecipientSelectHelper = selectHelper.getHelper(ccRecipient);
            var ccEmailTypeSelectHelper = selectHelper.getHelper(ccEmailType);

            // batch type change - visibility/disabled changes
            batchType.change(function () {
                batchType.clearErrors();

                if (isDirectDepositsOrTaxForms()) {
                    sendTo.clearErrors();
                    headingAddressType.clearErrors();

                    sendToSelectHelper.addEmptyOption().selectIndex(0).setDisabled(true);
                    headingAddressTypeSelectHelper.clearOptions().setDisabled(true);

                    reloadHeadingAddress();

                    if (deliveryMethod.val() == constants.email) {
                        visibility.setVisible(emailInfoPanel, true);
                        visibility.setVisible(emailAdditionalInfoPanel, false);

                        ccRecipientSelectHelper.setValue("");

                        reloadCCEmailAddressTypes();
                        reloadCCEmailAddress();
                    }
                }
                else {
                    sendToSelectHelper.removeEmptyOption().setDisabled(false);
                    headingAddressTypeSelectHelper.setDisabled(false);

                    reloadHeadingAddressTypes();
                    reloadHeadingAddress();

                    if (deliveryMethod.val() == constants.email) {
                        visibility.setVisible(emailInfoPanel, true);
                        visibility.setVisible(emailAdditionalInfoPanel, true);
                    }
                }
            });

            // send to change - repopulate heading types/address, email types/address, repopulate CC recipients/email types/address
            sendTo.change(function () {
                sendTo.clearErrors();

                reloadHeadingAddressTypes();
                reloadHeadingAddress();

                reloadEmailAddressTypes();
                reloadEmailAddress();

                reloadCCRecipients();
            });

            // heading address type change - repopulate heading address
            headingAddressType.change(function () {
                headingAddressType.clearErrors();
                reloadHeadingAddress();
            });

            // delivery method dropdown change - show/hide email panels and clear associated values as needed
            deliveryMethod.change(function () {
                if (deliveryMethod.val() == constants.email) {
                    visibility.setVisible(emailInfoPanel, true);
                    visibility.setVisible(emailAdditionalInfoPanel, !isDirectDepositsOrTaxForms());

                    // this is necessary because the Distribution Address Type field is (sometimes) shared between both mail and email Delivery Methods
                    // because of that, when the user loads the page, Email Type could be incorrectly populated with the physical address type (if distributed by mail)
                    // we don't want that - so always clear the type out if the user is changing the Delivery Method from mail to email
                    emailTypeSelectHelper.setValue("");

                    reloadEmailAddress();
                }
                else {
                    visibility.setVisible(emailInfoPanel, false);
                    visibility.setVisible(emailAdditionalInfoPanel, false);

                    emailTypeSelectHelper.setValue("");
                    ccRecipientSelectHelper.setValue("");
                    ccEmailTypeSelectHelper.setValue("");

                    emailType.clearErrors();
                    ccRecipient.clearErrors();
                    ccEmailType.clearErrors();
                }
            });

            // email type change - repopulate email address
            emailType.change(function () {
                emailType.clearErrors();
                reloadEmailAddress();
            });

            // selected password type change - show/hide change password link and custom password panel
            selectedPasswordType.change(function () {
                if (changePasswordLink) {
                    visibility.setVisible(changePasswordLink, selectedPasswordType.val() == constants.custom);
                }

                visibility.setVisible(customPasswordPanel, selectedPasswordType.val() == constants.custom);

                originalPassword.val("").clearErrors();
                confirmedPassword.val("").clearErrors();
            });

            // change password link click - change text, show/hide inputs/placeholders
            changePasswordLink.click(function () {
                if (changePasswordLink.text() == constants.passwordChange) {
                    hasPasswordChanged.val(true);
                    changePasswordLink.text(constants.passwordChangeCancel);

                    visibility.setVisible(originalPassword, true);
                    visibility.setVisible(confirmedPassword, true);

                    visibility.setVisible(originalPasswordPlaceholder, false);
                    visibility.setVisible(confirmedPasswordPlaceholder, false);
                }
                else {
                    hasPasswordChanged.val(false);
                    changePasswordLink.text(constants.passwordChange);

                    visibility.setVisible(originalPassword, false);
                    visibility.setVisible(confirmedPassword, false);

                    originalPassword.val("").clearErrors();
                    confirmedPassword.val("").clearErrors();

                    visibility.setVisible(originalPasswordPlaceholder, true);
                    visibility.setVisible(confirmedPasswordPlaceholder, true);
                }
            });

            // cc recipient change - repopulate cc address/types
            ccRecipient.change(function () {
                ccRecipient.clearErrors();
                ccEmailType.clearErrors();

                reloadCCEmailAddressTypes();
                reloadCCEmailAddress();
            });

            // cc email type change - repopulate cc address
            ccEmailType.change(function () {
                ccRecipient.clearErrors();
                ccEmailType.clearErrors();

                reloadCCEmailAddress();
            });

            // reload available Heading Address Types for the selected Send To value
            function reloadHeadingAddressTypes() {
                headingAddressTypeSelectHelper.loadOptionsFrom(
                    backendUrls.getHeadingAddressTypes,
                    { ownerKey: getAddressOwnerKey() },
                    { withBlank: true },
                    function () { }
                );
            }

            // reload heading address for the selected Send To/Heading Address Type values
            function reloadHeadingAddress() {

                if (headingAddressType.val()) {
                    $.ajax({
                        url: backendUrls.getHeadingAddress,
                        data: {
                            addressType: headingAddressType.val(),
                            ownerKey: constants.addressOwnerKey,
                            ownerType: constants.ownerType,
                            ownerName: constants.ownerName,
                            contactKey: sendTo.val() != constants.ownerKey ? sendTo.val() : null,
                        },
                        success: function (data) {
                            headingAddress.html(data);
                        }
                    });
                }
                else {
                    visibility.setVisible(headingAddress, false);
                    headingAddress.html("");
                }
            }

            // reload email address types for the selected Send To value
            function reloadEmailAddressTypes() {
                emailTypeSelectHelper.loadOptionsFrom(
                    backendUrls.getEmailAddressTypes,
                    { ownerKey: getAddressOwnerKey() },
                    { withBlank: true },
                    function () { }
                );
            }

            // reload email address for the selected values
            function reloadEmailAddress() {

                var ownerKey = getAddressOwnerKey();

                if (ownerKey && emailType.val()) {
                    $.ajax({
                        url: backendUrls.getEmailAddress,
                        data: {
                            ownerKey: ownerKey,
                            emailType: emailType.val()
                        },
                        success: function (data) {
                            if (data) {
                                email.text(data);
                                visibility.setVisible(email, true);
                            }
                        }
                    });
                }
                else {
                    visibility.setVisible(email, false);
                    email.text("");
                }
            }

            // reload CC recipients, excluding the currently selected Send To value
            function reloadCCRecipients() {

                // get the selected recipient before reload
                var previouslySelectedRecipient = ccRecipient.val();

                // replace the options, maintaining the previous selection (if applicable)
                ccRecipientSelectHelper.replaceOptions(constants.availableRecipients.filter(_ => _.Value != sendTo.val()), { withBlank: true, maintainSelection: true });

                // only reload types/address if the CC Recipient field changed
                // (that is, the previously selected CC recipient is now selected for Send To, and thus has been removed from the CC Recipients list)
                if (sendTo.val() == previouslySelectedRecipient) {
                    reloadCCEmailAddressTypes();
                    reloadCCEmailAddress();
                }
            }

            // reload available CC Recipient Email Types for the selected CC Recipient value
            function reloadCCEmailAddressTypes() {
                if (ccRecipient.val()) {
                    ccEmailTypeSelectHelper.loadOptionsFrom(
                        backendUrls.getEmailAddressTypes,
                        { ownerKey: ccRecipient.val() },
                        { withBlank: true },
                        function () {
                            ccEmailTypeSelectHelper.setDisabled(false);
                        }
                    );
                }
                else {
                    ccEmailTypeSelectHelper.clearOptions().addEmptyOption().setDisabled(true);

                    visibility.setVisible(ccEmail, false);
                    ccEmail.text("");
                }
            }

            // reload email address for the selected CC Recipient/CC Recipient Email Type values
            function reloadCCEmailAddress() {
                if (ccRecipient.val() && ccEmailType.val()) {
                    $.ajax({
                        url: backendUrls.getEmailAddress,
                        data: { ownerKey: ccRecipient.val(), emailType: ccEmailType.val() },
                        success: function (data) {
                            ccEmail.text(data);
                            visibility.setVisible(ccEmail, true);
                        }
                    });
                }
                else {
                    visibility.setVisible(ccEmail, false);
                    ccEmail.text("");
                }
            }

            // helper to determine if the selected batch is Direct Deposit Receipts or Tax Forms
            function isDirectDepositsOrTaxForms() {
                return batchType.val() == constants.directDepositReceipts || batchType.val() == constants.taxForms;
            }

            // helper to resolve the address owner key
            function getAddressOwnerKey() {
                var selectedRecipient = sendTo.val();

                // if selected recipient non-empty and is not the preference owner, a contact is selected; use the contact key as address owner key
                // if selected recipient is empty or is the preference owner; use the passed in address owner key
                return (selectedRecipient && selectedRecipient != constants.ownerKey) ? selectedRecipient : constants.addressOwnerKey;
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);